import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ComprobanteDialog from "../components/ComprobanteDialog";

// Comprobante de cheque a pantalla completa, sin el menú general: se abre en otra pestaña desde el ID de "Cheques emitidos".
// Tiene las mismas opciones que el diálogo (imprimir, editar, facturas, gastos…).
export default function ComprobantePage() {
  const { id } = useParams();

  useEffect(() => {
    const anterior = document.title;
    document.title = `Comprobante N° ${id}`;
    return () => { document.title = anterior; };
  }, [id]);

  return <ComprobanteDialog id={id} pagina />;
}
